import { useNavigate } from 'react-router-dom';
import { useGetUserIdentities } from '../../../domains/user/ui/hooks/useGetUserIdentities';
import type { PaymentRequest } from '../../../domain/models/payments/Payment';
import { usePayment } from './usePayment';
import type { OrderProductType } from '../../../domain/repositories/PaymentRepository';

interface UseInicisPaymentProps {
  amount: string;
  productName: string;
  productId: string;
  productType?: OrderProductType;
  sceneId?: string;
}

export const useInicisPayment = ({
  amount,
  productName,
  productId,
  productType,
  sceneId
}: UseInicisPaymentProps) => {
  const navigate = useNavigate();
  const { data: userIdentity, isLoading: isLoadingUserIdentities } = useGetUserIdentities();
  const { generateOrderId, requestPayment } = usePayment();

  const handleCreateOrder = async () => {
    if (!productId || isLoadingUserIdentities || !userIdentity) return;
    try {
      // 1) 주문번호 생성 (UseCase)
      const orderId = await generateOrderId(productId, productType, sceneId);

      // 2) 결제 요청 데이터 구성
      const payload: PaymentRequest = {
        gopaymethod: 'CARD',
        mid: 'myshopif17',
        oid: orderId,
        price: Number(amount),
        goodname: productName,
        buyername: userIdentity.name,
        buyertel: userIdentity.phoneNumber,
        buyeremail: userIdentity.email
      };

      // 3) 결제 요청 (UseCase 통해 Repository로 위임)
      await requestPayment(payload);
    } catch {
      navigate('/payment/fail');
    }
  };
  return { handleCreateOrder };
};
